import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'app-metric-rectangle',
  templateUrl: './metric-rectangle.component.html',
  styleUrls: ['metric-rectangle.component.css']
})

export class MetricRectangleComponent implements OnInit {
  @Input('title') title: string;
  @Input('actionCounter') actionCounter: number;
  @Input('actionProgress') actionProgress: string;
  @Input('note') note: string;
  @Input('icon') icon: string;
  @Input('color') color: string;

  @ViewChild('progressBar') progressBar: ElementRef;
  
  self:ElementRef;

  constructor(myElement: ElementRef) {
    this.self = myElement;
  }

  ngAfterContentInit() {
    this.progressBar.nativeElement.style.width = this.actionProgress + "%";
    this.self.nativeElement.style.backgroundColor = this.color;
  }

  ngOnInit() {

  }

  // ngOnInit() {
  //   this.animateNumber(2000);
  // }

  // animateNumber(duration) {
  //   var range = this.actionCounter - 0;
  //   var current = 0;
  //   var increment = this.actionCounter > 0 ? 1 : -1;
  //   var stepTime = Math.abs(Math.floor(duration / range));
  //   var timer = setInterval(function () {
  //     current += increment;
  //     // el.nativeElement.innerText = current;
  //     if (current == this.actionCounter) {
  //       clearInterval(timer);
  //     }
  //   }, stepTime);
  // }
}
